import { IExtendableDto, IRideDto } from "@ryde/shared";

export const buildRecordSwitchResetValues = (
  currentValues: IExtendableDto,
  dto: Partial<IRideDto> | undefined,
): IExtendableDto => {
  const currentMetadata = currentValues?.metadata as object | undefined;
  const blankedMetadata: Record<string, null> = {};
  Object.keys(currentMetadata || {}).forEach(key => {
    blankedMetadata[key] = null;
  });

  const hasMetadata = Boolean(dto?.metadata) || Boolean(currentMetadata);

  return {
    ...dto,
    ...(hasMetadata
      ? { metadata: { ...blankedMetadata, ...(dto?.metadata || {}) } }
      : {}),
  } as IExtendableDto;
};
